<script>
import PictureLazyMixin from '@phoenix/mixins/components/common/PictureLazyMixin';

export default {
  mixins: [PictureLazyMixin],
};
</script>

<template>
  <picture>
    <source
      v-for="source in sources"
      :key="source.media"
      :media="source.media"
      :srcset="source.srcset"
      :width="source.width"
      :height="source.height"
    />
    <img
      :src="image.src"
      :srcset="image.srcset"
      :class="[imgClass, { 'picture--fade': fade }]"
      :alt="alt"
      :width="imgWidth"
      :height="imgHeight"
      :loading="lazy ? 'lazy' : 'eager'"
    />
  </picture>
</template>
